<template>
    <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="分成模式：">
              <el-select style="width: 200px;" v-model="formInline.mode" filterable placeholder="请选择">
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="合作方：">
              <el-select style="width: 200px;" v-model="formInline.partnerId" filterable placeholder="请选择">
                <!-- 全部 -->
                 <el-option
                  label="全部"
                  value="">
                  </el-option>
                  <el-option
                  v-for="item in partnerList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="关键字：">
              <el-input v-model="formInline.name" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" @click="showAdd()">新建</el-button>
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <!-- <el-table-column label="ID" width="80">
          <template #default="scope">
            <div>
              <span>{{scope.row.id}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="模板名称" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分成模式" width="200">
          <template #default="scope">
            <div>
              <span>{{ typeFilter(scope.row.mode) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分成系数" width="100">
          <template #default="scope">
            <div>
              <span>{{ scope.row.coeff || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合作方" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.partnerName || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template #default="scope">
            <div>
              <span>{{ scope.row.createTime || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
  
      <!-- 对话框--新建、编辑组织 -->
      <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
          <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
          <el-form-item label="模板名称" prop="name">
            <el-input v-model="addInfo.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="分成模式" prop="mode">
            <el-select v-model="addInfo.mode" placeholder="请选择">
              <el-option
                  v-for="item in rolesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分成系数" prop="coeff">
            <el-input v-model="addInfo.coeff" autocomplete="off" />
          </el-form-item>
          <el-form-item label="合作方" prop="partnerId">
                <el-select v-model="addInfo.partnerId" placeholder="请选择合作方">
                <el-option
                    v-for="item in partnerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="saveInfo()">确定</el-button>
          </div>
          </template>
      </el-dialog>
  
      <!-- 对话框--删除 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定删除该模板吗？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deleteUser()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
    </template>
    
    <script>
    import { required, isPrice, noSpecialChar, isPriceGreaterThan } from '@/utils/validators';
    export default {
    name:'SplitTemplate',
    data() {
      return {
        formInline:{
          mode:'',
          name:''
        },
        partnerList:[],
        typeOptions:[
          {
            label:'全部',
            value:''
          },
          {
            label:'电量分成',
            value:1
          },
          {
            label:'服务费分成',
            value:2
          },
          {
            label:'收益分成',
            value:3
          }
        ],
        selectedRoles: [],
        rolesList:[
          {
            label:'电量分成',
            value:1
          },
          {
            label:'服务费分成',
            value:2
          },
          {
            label:'收益分成',
            value:3
          }
        ],
        isUpdate:false,
        dialogTitle:'添加分成方',
        dialogFormVisible:false,
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        tableData:[],
        addFormRef: null,
        addRules: {
          name: [required('请输入模板名称'), noSpecialChar('模板名称不能包含特殊字符')],
          mode: [required('请选择分成模式')],
          coeff: [required('请输入分成系数'), isPrice('分成系数只能输入正数或小数'), isPriceGreaterThan(0.01, '分成系数必须大于0.01')],
          partnerId: [required('请选择合作方')],
        },
        addInfo:{
          name:'',
          type:'',
          username:'',
          account:'',
          bankOf:'',
          date:[],
          time:'',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      this.getList();
      this.getPartnerList();
    },
    methods:{
      getPartnerList(){
        //获取合作方列表
        let that = this;
        let param = {};
        that.$axios.post(that.$store.state.platformApi + "partner/list", JSON.stringify(param)).then(result => {
            if(result.code === 200){
                result.data.forEach(item => {
                    let item_obj = {};
                    item_obj.label = item.name;
                    item_obj.value = item.id;
                    that.partnerList.push(item_obj);
                });
            }
        });
      },
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList();
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(); //获取列表
      },
      search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.mode = that.formInline.mode;
        param.name = that.formInline.name;
        param.partnerId = that.formInline.partnerId;
        // console.log(that.formInline);
        if(that.formInline.date && that.formInline.date.length > 0){
          param.start = that.formInline.date[0];
          param.end = that.formInline.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"split/template/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      getList(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        param.mode = that.formInline.mode;
        param.name = that.formInline.name;
        param.partnerId = that.formInline.partnerId;
        that.$axios.post(that.$store.state.platformApi+"split/template/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        // 表单校验
        this.$refs.addFormRef.validate((valid) => {
          if (!valid) return;
          let param = {};
          if(that.isUpdate){
            //编辑
             var url = that.$store.state.platformApi+"split/template/update";
          }else{
              var url = that.$store.state.platformApi+"split/template/add";
          }
          param = this.addInfo;
          that.$axios.post(url,JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 保存成功
              that.dialogFormVisible = false;
              that.getList();
            }
          });
        });
      },
      showAdd(index,row){
        //打开添加弹窗
          this.isUpdate = false;
          this.dialogTitle = '添加模板';
          this.addInfo = Object.fromEntries(
            Object.keys(this.addInfo).map(key => [key, ''])
          );
          this.dialogFormVisible = true;
      },
      handleEdit(index,row){
        //打开编辑
        this.dialogTitle = '编辑模板';
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.addInfo = row;
      },
      deleteUser(){
        //删除
        let that = this;
        that.$axios.post(that.$store.state.platformApi+"split/template/delete/"+that.currt_id).then(result => {
          // console.log(result);
          if(result.code==200){
            that.centerDialogVisible = false;
            that.getList();
          }
        })
      },
      handleDelete(index,row){
          //删除弹窗
        this.centerDialogVisible = true;
        this.currt_id = row.id;
      },
      typeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '电量分成';
          case 2:
            return '服务费分成';
          case 3:
            return '收益分成';
          default:
            return value;
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  </style>